import React, { useCallback } from 'react';
import { useEventHasMap } from '../../../../../../data/hooks/eventHooks';

import Icon from '../../../../../elements/icons/Icon';
import Link from '../../../../../elements/Link';
import styles from '../EventIcons.module.scss';

const Map = (props) => {
    const { event, i18n } = props,
        hasMap = useEventHasMap();

    const handleOpenMap = useCallback(() => app.store.dispatch(app.actions.ui.sidePanel.showEventMap(true)), [event]);

    if (!hasMap) return null;

    return (
        <Link className={styles.icon} onClick={handleOpenMap}>
            <Icon src="/img/event_map.png" color={event.settings.secondary_color} />
            <div>{i18n['label.map']}</div>
        </Link>
    );
};

export default Map;
